/* eslint-disable @typescript-eslint/no-unused-vars, no-param-reassign */

import {
  config,
  State as AuthState,
  setActions,
  saga as authSaga,
  updateConfig,
  getLocalState,
  createUrl,
  refreshTokenSaga,
  reducers, Token, updateStorageSaga,
} from '@triare/auth-redux';
import {
  createSlice,
  PayloadAction,
} from '@reduxjs/toolkit';
import {
  spawn, takeLatest, select, delay, call,
} from 'redux-saga/effects';
import { EnhancedStore } from '@reduxjs/toolkit/src/configureStore';
import { useSelector } from 'react-redux';
import { UrlObject } from '@triare/auth-redux/src/config';
import { AnyObject } from '@triare/auth-redux/src/saga/common';
import { userMeRequestSaga } from '@triare/auth-redux/dist/saga/auth/useMe';
import { RootState } from '../index';
import { UserRole } from '../../enums/user';

export * from '@triare/auth-redux';

export default updateConfig({
  name: 'gruuun-admin',
  displayName: 'grüüün',
  fetchDelay: Number.parseInt(process.env.REACT_APP_FETCH_DELAY || '0', 10),
  api: {
    url: process.env.REACT_APP_API || '',
  },
  signIn: {
    // make sure that all 2FA params are saved in store
    prepareData: (res: State2FAParams & AnyObject) => res,
  },
  // signIn: {
  //   ...config.signIn,
  //   refreshToken: {
  //     ...config.refreshToken,
  //     method: HttpMethod.POST,
  //   },
  //   requestBody: {
  //     byEmail: ({ remember, ...data }: SignInAction) => JSON.stringify(data),
  //     byUsername: ({ remember, ...data }: SignInAction) => JSON.stringify(data),
  //     byPhone: ({ remember, ...data }: SignInAction) => JSON.stringify(data),
  //     byService: ({ method, remember, ...data }: SignInAction) => JSON.stringify(data),
  //   },
  //   fetchMeAfterSuccess: true,
  // },
  createUrl: (
    url: string | UrlObject,
    addToUrl?: string,
    payload?: PayloadAction,
    data?: AnyObject,
    _query?: AnyObject,
  ) => createUrl(url, addToUrl, payload, data, {
    ..._query,
    // lang: 'en',
  }),
});

export const moduleName = config.auth.name;

export type UserRoleType = UserRole.GUEST
  | UserRole.USER
  | UserRole.EDITOR
  | UserRole.MITARBEITER
  | UserRole.ADMIN
  | UserRole.ROOT;
export type UserStatusType = 'active' | 'deactivated' | 'pending' | 'blocked'; // TODO upd

interface ITempUser {
  id: string;
}

export interface User extends ITempUser {
  firstName: string;
  lastName: string; // name = lastName
  email: string;
  phone: string;
  role: UserRoleType;
  status: UserStatusType;
  isTwoFAActive: boolean;
  hasMobileApp: boolean;
  isPrivate: boolean;
  settings: {
    isEmailVerified: boolean;
    isPhoneVerified: boolean;
  };
}

export interface State extends AuthState, State2FAParams {
  user: User | null;
  secretKey: string;
}

export interface State2FAParams {
  requiresOtpVerification?: boolean;
  qrCode?: string;
  secret?: string;
  requiresSetup?: boolean;
}

export function useAuth(): State {
  return useSelector((state: RootState) => state[moduleName]);
}

export const auth = createSlice({
  name: moduleName,
  initialState: getLocalState<State>(),
  reducers: {
    ...reducers,
    updateTokensSuccess: (
      state,
      action: PayloadAction<{ access: Token; refresh: Token }>,
    ) => {
      // 1. Update access token state
      state.access = action.payload.access;

      // 2. Update refresh token state (if returned by backend)
      if (action.payload.refresh) {
        state.refresh = action.payload.refresh;
      }

      // 3. Flip authentication guards
      state.authorized = true;
      state.requiresSetup = false;
      state.requiresOtpVerification = false;
      state.qrCode = undefined;
      state.secret = undefined;
    },

    // signInSuccess: (state, { payload }) => { // TODO uncomment
    //   Object.assign(state, payload);
    //
    //   state.signIn.loading = false;
    //   state.signIn.response = payload || null;
    //
    //   if (payload?.remember !== undefined) {
    //     state.remember = payload?.remember;
    //   }
    // },
  },
});

export const { actions } = auth;

setActions(actions);

function* selectAuthState() {
  return (yield select((state: RootState) => state[moduleName])) as State;
}

function* handleTwoFASetupSuccessSaga() {
  // Syncs the access and refresh tokens from Redux state into Cookies/LocalStorage
  yield call(updateStorageSaga);

  // Requests the authenticated user's profile metadata from the backend
  yield call(userMeRequestSaga);
}

export function* saga(store: EnhancedStore) {
  yield spawn(authSaga, store);

  yield takeLatest([actions.signInSuccess.toString(), actions.refreshTokenSuccess.toString()], function* trigger() {
    yield delay(100);

    const authStore = (yield selectAuthState()) as State;
  });

  /** If user-me fails - trigger refresh-token */
  yield takeLatest([config.actions.userMeError.toString()], refreshTokenSaga);

  /** * Listen for custom 2FA verification success action
   * and chain the library's internal storage and user synchronization routines
   */
  yield takeLatest(
    actions.updateTokensSuccess.toString(),
    handleTwoFASetupSuccessSaga,
  );

  // yield takeLatest(actions.confirmSuccess.toString(), (data) => {
  //   console.log(data);
  // });

  // yield takeLatest(actions.userMeSuccess.toString(), function* trigger() {
  //   const authData = (yield getState()) as State;
  //
  //   if (authData && authData.user && authData.user.role === UserRoles.GUEST) {
  //     yield put(signOut());
  //
  //     window.location.href = '/sign-up';
  //   }
  // });
}
